(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[70235],{

/***/ 11614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Detail_Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80103);
/* harmony import */ var _context_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94268);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73040);






var FavBtn = function(param) {
    var className = param.className, hideText = param.hideText, data = param.data, inlineclass = param.inlineclass;
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .m)(), addFavourite = ref.addFavourite, removeFavourite = ref.removeFavourite, favouriteAria = ref.favouriteAria;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_context__WEBPACK_IMPORTED_MODULE_3__/* .StoreContext */ .x), favourites = ref1.favourites, setFavourites = ref1.setFavourites;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isAdded = ref2[0], setIsAdded = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsAdded(favourites.find(function(x) {
            return x.id == data.id;
        }) ? true : false);
        localStorage.setItem("Favourites", JSON.stringify(favourites));
    }, [
        favourites
    ]);
    var HandClick = function(e) {
        var result = favourites.findIndex(function(x) {
            return x.id == data.id;
        });
        var a = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(favourites);
        if (result > -1) {
            a.splice(result, 1);
            setFavourites(a);
        } else {
            setFavourites((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(favourites).concat([
                data
            ]));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: className,
        type: "button",
        onClick: HandClick,
        "aria-label": favouriteAria,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (inlineclass ? inlineclass : "w-10 h-10 rounded-full   p-2.5 bg-white  transition-colors ") + (isAdded ? "text-red-600" : "text-heart-bg"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Detail_Icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    name: "heart"
                })
            }),
            !hideText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "font-bold text-xxs text-brand-black -mt-3",
                children: isAdded ? removeFavourite : addFavourite
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "inner"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(FavBtn));


/***/ }),

/***/ 71700:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var Local = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return "".concat(src, "?quality=").concat(quality || 75);
};
/* harmony default export */ __webpack_exports__["Z"] = (Local);


/***/ }),

/***/ 70235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _LoaderRemote__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71593);
/* harmony import */ var _ImageLoader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71700);
/* harmony import */ var _FavBtn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11614);
/* harmony import */ var _DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16543);
/* harmony import */ var _VillaItem_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49601);
/* harmony import */ var _VillaItem_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_VillaItem_module_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73040);
/* harmony import */ var _helper_date__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41937);











//import Lottie from "lottie-react";
//import animation from "../animations/maximize.json";
var Price = function(param) {
    var text = param.text, price = param.price, price2 = param.price2, night = param.night;
    var nightly = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .m)().nightly;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "text-xl font-semibold text-brand-color-secondary",
                    children: [
                        price,
                        " ",
                        !night && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
                            className: "text-sm text-black -top-0.5 relative",
                            children: [
                                "/",
                                nightly
                            ]
                        })
                    ]
                }),
                text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "inline-block text-sm font-semibold opacity-30",
                    children: text
                })
            ]
        })
    });
};
var VillaItem = function(param) {
    var data = param.data, className = param.className, lastMinute = param.lastMinute, shortTerm = param.shortTerm, index = param.index;
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .m)(), viewDetailUpper = ref.viewDetailUpper, nightUpper = ref.nightUpper, person = ref.person, bedRoom = ref.bedRoom, bathRoom = ref.bathRoom, villaItemPrice = ref.villaItemPrice, villaItemPriceNightly = ref.villaItemPriceNightly, lastMinuteBadge = ref.lastMinuteBadge, nights = ref.nights, discountedBadge = ref.discountedBadge, instantBooking = ref.instantBooking;
    var style = {
        height: 32,
        width: 32
    };
    if (data.isSonDakika == "1" || shortTerm == 1) {
        lastMinute = 1;
    }
    // Listeleme sayfasında (tarihsiz arama) API her villanın altına sonDakika nesnesi döndürür
    var sonDakika = (data === null || data === void 0 ? void 0 : data.sonDakika) ? data.sonDakika : null;
    var sonDakikaStart = sonDakika ? (0,_helper_date__WEBPACK_IMPORTED_MODULE_7__/* .toIsoDate */ .v)(sonDakika.tarih1) : "";
    var sonDakikaEnd = sonDakika ? (0,_helper_date__WEBPACK_IMPORTED_MODULE_7__/* .toIsoDate */ .v)(sonDakika.tarih2) : "";
    // URL zaten tarihli geliyorsa (son dakika sayfası / anasayfa) tekrar tarih ekleme
    var sonDakikaUrl = sonDakikaStart && sonDakikaEnd && !data.url.includes("start=") ? data.url + (data.url.includes("?") ? "&" : "?") + "start=" + sonDakikaStart + "&end=" + sonDakikaEnd : data.url;
    // Tarihsiz listelerde: en düşük gecelik fiyat indirimliyse eski fiyatı da göster
    var minfiyatIndirimli = !data.geceFark && parseInt(data === null || data === void 0 ? void 0 : data.minfiyatIndirimsiz) > parseInt(data === null || data === void 0 ? void 0 : data.minfiyat);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col relative " + (className ? className : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: data.url,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    title: data.title,
                    className: "relative h-52 lg:h-72 group",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative w-full h-full overflow-hidden",
                            children: [
                                data.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    src: data.image,
                                    layout: "fill",
                                    loader: _LoaderRemote__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                                    alt: data.title,
                                    objectFit: "cover",
                                    sizes: "(max-width: 425px) 70vw,(max-width: 768px) 30vw, (max-width: 1200px) 50vw, 33vw",
                                    placeholder: "blur",
                                    blurDataURL: (0,_LoaderRemote__WEBPACK_IMPORTED_MODULE_8__/* .Blur */ .x)(data.image),
                                    priority: index == 0
                                }),
                                (data === null || data === void 0 ? void 0 : data.IndirimTutari) > 0 || !lastMinute && !sonDakika && minfiyatIndirimli ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute top-0 left-0 px-4 py-1 text-sm font-bold text-white bg-red-500 rounded-br-lg animate-slide-in",
                                    children: discountedBadge
                                }) : ""
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute bottom-0 left-0 items-center justify-center hidden w-full transition-all lg:flex bg-villa-item transform-gpu h-2/3 group-hover:h-full group-hover:bg-villa-item2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "px-6 py-5 text-sm font-bold leading-5 text-white border opacity-0 group-hover:opacity-100",
                                children: viewDetailUpper
                            })
                        }),
                        data.ribbon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute text-white font-bold text-sm bottom-2 ".concat((_VillaItem_module_css__WEBPACK_IMPORTED_MODULE_9___default().Ribbon), "  ").concat(lastMinute ? "left-6" : "left-2 lg:left-auto lg:right-2"),
                            children: data.ribbon
                        })
                    ]
                })
            }),
            sonDakika && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: sonDakikaUrl,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    title: data.title,
                    className: "absolute top-0 left-0 z-10 overflow-hidden rounded-br-lg shadow-md group animate-slide-in",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative flex items-center gap-1 py-1 pl-2 pr-3 font-bold text-white text-xxs tracking-1 " + (_VillaItem_module_css__WEBPACK_IMPORTED_MODULE_9___default().SonDakikaBadge),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    className: "w-3 h-3 shrink-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fillRule: "evenodd",
                                        d: "M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143z",
                                        clipRule: "evenodd"
                                    })
                                }),
                                lastMinuteBadge
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col px-2 py-1.5 leading-tight bg-white bg-opacity-95",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "font-semibold text-brand-black text-[11px]",
                                    children: [
                                        sonDakika.gun1,
                                        " - ",
                                        sonDakika.gun2,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "ml-1 opacity-50",
                                            children: [
                                                sonDakika.gece,
                                                " ",
                                                nights
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "flex items-baseline gap-1.5",
                                    children: [
                                        parseInt(sonDakika.eskiFiyat) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[11px] font-semibold text-red-600 line-through opacity-80",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                value: parseInt(sonDakika.eskiFiyat),
                                                Symbol: sonDakika.Symbol || data.Symbol
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-sm font-bold text-[#E01252] group-hover:underline",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                value: parseInt(sonDakika.fiyat),
                                                Symbol: sonDakika.Symbol || data.Symbol
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            (data === null || data === void 0 ? void 0 : data.BookableDirectly) == "1" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "group absolute top-1 right-12 flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-yellow-100 text-yellow-600 shadow-sm transition-all duration-300 hover:w-44 hover:justify-start hover:px-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                        className: "h-5 w-5 shrink-0 animate-pulse",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143z",
                            clipRule: "evenodd"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "max-w-0 overflow-hidden whitespace-nowrap text-xs font-bold opacity-0 transition-all duration-300 group-hover:ml-2 group-hover:max-w-[150px] group-hover:opacity-100",
                        children: instantBooking
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FavBtn__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                hideText: true,
                className: "absolute top-0 right-0 flex flex-col ",
                inlineclass: "w-10 h-10 p-2.5 bg-white bg-opacity-90 transition-colors rounded-bl-lg ",
                data: {
                    id: data.id,
                    baslik: data.name,
                    destination: data.destination,
                    url: data.url,
                    image: data.image
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col " + (lastMinute ? "bg-white" : "ListVillaBg"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between px-2 py-5 border-b ml:px-5 lg:px-7 border-brand-gray-7",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: "text-brand-black lg:text-xl",
                                        children: data.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex mt-1 lg:mt-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "/icons/villaLocationIcon.svg",
                                                width: 16,
                                                height: 18,
                                                alt: "Villa Location Icon",
                                                className: "iconsImgFilter"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "ml-2 font-bold opacity-50 text-13 lg:text-sm",
                                                children: data.destination
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col items-end text-right ",
                                children: lastMinute ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col-reverse items-end -mt-12 sm:items-center sm:mt-0 sm:flex-row",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col-reverse sm:mr-2 sm:flex-col",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
                                                    className: "text-xs font-semibold text-black",
                                                    children: [
                                                        data.gun1,
                                                        "-",
                                                        data.gun2
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex flex-col items-end sm:items-center",
                                                    children: [
                                                        !shortTerm && parseInt(data === null || data === void 0 ? void 0 : data.eskiFiyat) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "block text-sm font-semibold text-red-600 line-through sm:text-base",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                value: parseInt(data.eskiFiyat),
                                                                Symbol: data.Symbol
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-lg font-bold sm:text-xl text-brand-color-secondary",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                value: shortTerm ? data.sqfiyat : data.fiyat,
                                                                Symbol: data.Symbol
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "w-12 h-12 z-10 bg-white text-center font-semibold text-brand-gray-2 text-xs px-2 pt-2 rounded-sm border-2 border-[#DFE2E2]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    children: shortTerm ? data.geceFark : data.gece
                                                }),
                                                " ",
                                                nightUpper
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Price, {
                                    night: data.geceFark,
                                    text: data.geceFark ? data.geceFark + " " + villaItemPriceNightly : villaItemPrice,
                                    price: data.geceFark ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            (data === null || data === void 0 ? void 0 : data.IndirimTutari) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "block text-base text-center text-red-600 line-through",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    value: parseInt(data.IndirimTutari) + parseInt(data.sqfiyat),
                                                    Symbol: data.Symbol
                                                })
                                            }) : "",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                value: parseInt(data.sqfiyat),
                                                Symbol: data.Symbol
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            minfiyatIndirimli && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "block text-base text-center text-red-600 line-through",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    value: parseInt(data.minfiyatIndirimsiz),
                                                    Symbol: data.Symbol
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                value: parseInt(data.minfiyat),
                                                Symbol: data.Symbol
                                            })
                                        ]
                                    }),
                                    price2: data.geceFark ? false : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        value: parseInt(data.maxfiyat),
                                        Symbol: data.Symbol
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "justify-between hidden px-2 pt-5 pb-7 ml:px-7 lg:flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "/icons/villaItemProp1.svg",
                                        width: "19",
                                        className: "iconsImgFilter",
                                        height: "21",
                                        alt: person,
                                        loader: _ImageLoader__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col ml-3 text-sm font-bold leading-4 text-black",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: data.kisi
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: person
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "/icons/villaItemProp2.svg",
                                        width: "19",
                                        height: "21",
                                        className: "iconsImgFilter",
                                        alt: bedRoom,
                                        loader: _ImageLoader__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col ml-3 text-sm font-bold leading-4 text-black",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: data.yatak_odasi
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: bedRoom
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "/icons/villaItemProp3.svg",
                                        width: "19",
                                        className: "iconsImgFilter",
                                        height: "21",
                                        alt: bathRoom,
                                        loader: _ImageLoader__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col ml-3 text-sm font-bold leading-4 text-black",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: data.banyo
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: bathRoom
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center justify-between px-2 py-3 ml:px-7 lg:hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "text-sm font-bold text-brand-gray",
                                children: [
                                    data.kisi,
                                    " ",
                                    person,
                                    ", ",
                                    data.yatak_odasi,
                                    " ",
                                    bedRoom,
                                    ", ",
                                    data.banyo,
                                    " ",
                                    bathRoom
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: data.url,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    title: data.title
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VillaItem);


/***/ }),

/***/ 41937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ toIsoDate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);

// sonDakika tarihleri "gg.aa.yyyy" formatında gelir (gün/ay tek haneli olabilir),
// link ise "yyyy-aa-gg" bekler
var toIsoDate = function(value) {
    if (!value) return "";
    var parts = String(value).replace(/\//g, ".").split(".");
    if (parts.length != 3) return "";
    var _parts = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(parts, 3), day = _parts[0], month = _parts[1], year = _parts[2];
    if (!day || !month || !year) return "";
    return year + "-" + month.padStart(2, "0") + "-" + day.padStart(2, "0");
};


/***/ }),

/***/ 49601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Ribbon":"VillaItem_Ribbon__3AjfG","SonDakikaBadge":"VillaItem_SonDakikaBadge__HiiUD","sonDakikaShine":"VillaItem_sonDakikaShine__IPWP5","SonDakikaBar":"VillaItem_SonDakikaBar__h9oBI"};

/***/ })

}]);